/* ============================================
   SPOKEX THEME TOGGLE — JS
   ============================================ */

(function() {
  var STORAGE_KEY = 'spokex-theme';
  var BTN_ID = 'theme-toggle-btn';

  var sunIcon = '<svg viewBox="0 0 24 24"><path d="M12 7a5 5 0 100 10 5 5 0 000-10zM12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="#f5a623" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
  var moonIcon = '<svg viewBox="0 0 24 24"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" stroke="#888" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';

  function getTheme() {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  function applyTheme(theme) {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    localStorage.setItem(STORAGE_KEY, theme);
    updateToggleState(theme);
  }

  function injectToggle() {
    var btn = document.createElement('button');
    btn.id = BTN_ID;
    btn.className = 'theme-toggle-btn';
    btn.setAttribute('aria-label', 'Toggle theme');
    btn.innerHTML = '<span class="toggle-track"><span class="toggle-thumb">' + sunIcon + '</span></span>';
    btn.onclick = function() {
      var current = getTheme();
      var next = current === 'light' ? 'dark' : 'light';
      applyTheme(next);
    };
    document.body.appendChild(btn);
    updateToggleState(getTheme());
  }

  function updateToggleState(theme) {
    var btn = document.getElementById(BTN_ID);
    if (!btn) return;
    var thumb = btn.querySelector('.toggle-thumb');
    if (!thumb) return;

    if (theme === 'dark') {
      btn.classList.add('dark');
      thumb.innerHTML = moonIcon;
    } else {
      btn.classList.remove('dark');
      thumb.innerHTML = sunIcon;
    }
  }

  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function(e) {
      if (!localStorage.getItem(STORAGE_KEY)) {
        applyTheme(e.matches ? 'dark' : 'light');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectToggle);
  } else {
    injectToggle();
  }
})();